var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccess = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 73,
  height: 73,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#10D365",
  fillRule: "evenodd",
  d: "m31.478 40.236-3.896-3.857a3.035 3.035 0 0 0-4.262 0 2.96 2.96 0 0 0 0 4.219l6.027 5.966a3.035 3.035 0 0 0 4.261 0l16.072-15.91a2.96 2.96 0 0 0 0-4.218 3.035 3.035 0 0 0-4.262 0z",
  clipRule: "evenodd"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 36.5,
  cy: 36.5,
  r: 33,
  stroke: "#10D365",
  strokeWidth: 6
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccess);
export default ForwardRef;